import moment from 'moment';
import { recuperarDicFixatgesCalendari } from '../../actions/configAplicacioAction';
import { recuperarDetallMesComplet, IniciMesConsultat, FinalMesConsultat } from '../../actions/configCalendariAction';
import { uiAmagarIncidenciesAction, uiAmagarIncidenciesRestaHoresAction } from '../../actions/ui';

// SEMPRE carrega el mes actual, ignorant dates antigues al store
export const RecuperarInfoCalendar = (auth, ui) => {
    return (dispatch) => {
        const inici = moment().startOf('month').format('YYYY-MM-DD');
        const final = moment().endOf('month').format('YYYY-MM-DD');

        dispatch(IniciMesConsultat(inici));
        dispatch(FinalMesConsultat(final));
        dispatch(recuperarDicFixatgesCalendari(auth.tokenJwt));
        dispatch(recuperarDetallMesComplet(auth.tokenJwt, inici, final));

        if (ui.incidencia) dispatch(uiAmagarIncidenciesAction());
        if (ui.incidenciaRestaHores) dispatch(uiAmagarIncidenciesRestaHoresAction());
    };
};